/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
// BlogModalContent.js
import { ModalCloseButton } from '@chakra-ui/react';
import React from 'react';

const BlogModalContent = ({ blog, onClose }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const formattedDate = date.toLocaleDateString(undefined, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });
    const formattedTime = date.toLocaleTimeString(undefined, {
      hour: '2-digit',
      minute: '2-digit',
    });
    return `${formattedDate} ${formattedTime}`;
  };

return (
  <>

  <ModalCloseButton />

<main class="mt-10">

<div class="mb-4 md:mb-0 w-full max-w-screen-md mx-auto relative" style={{height: '24em'}}>
<div class="absolute left-0 bottom-0 w-full h-full z-10"
   style={{
    backgroundImage: 'linear-gradient(180deg, transparent, rgba(0, 0, 0, 0.7))',
  }}></div>
<img src={blog.image} />
<div class="p-4 absolute bottom-0 left-0 z-20">
  <a href="#"
    class="px-4 py-1 bg-black text-gray-200 inline-flex items-center justify-center mb-2">{blog.badges}</a>
  <h2 class="text-4xl font-semibold text-gray-100 leading-tight">
    {blog.title}
  </h2>
  <div class="flex mt-3">
    <div>
      <p class="font-semibold text-gray-200 text-sm">Author {blog.author}</p>
      <p class="font-semibold text-gray-400 text-xs">Published {formatDate(blog.date)}</p>
  
    </div>
  </div>
</div>
</div>

<div class="px-4 lg:px-0 mt-12 text-gray-400 max-w-screen-md mx-auto text-lg leading-relaxed">


<div class="border-l-4 border-warning px-4 mb-6 italic rounded">
  {blog.desc}
</div>



</div>
</main>
</>
)
};

export default BlogModalContent;
